var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.plan.status == 'published')?_c('a',{staticClass:"b-link b-link_primary",attrs:{"href":_vm.plan.url}},[_vm._v(_vm._s(_vm.plan.name))]):_c('span',[_vm._v(_vm._s(_vm.plan.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }